import { Modal } from 'react-bootstrap';
import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { toast } from 'sonner';
import { FileExplorerModalProps } from '../../../types/fileExplorerTypes';
import { replaceFile, TreeFile } from '../services';
import { ControlledModal } from '../../common/ControlledModal';
import { replaceFileSchema, ReplaceFileSchema } from '../Forms/schemas';
import { ReplaceFileForm } from '../Forms/ReplaceFileForm';
import { useFileExplorerMutation } from '../../../hooks/useFileExplorerMutation';

const GENERIC_ERROR_MESSAGE = 'Ocurrió un error al reemplazar el archivo. Por favor, intenta nuevamente.';

export function ReplaceFileModal({ show, onHide, data }: FileExplorerModalProps<TreeFile>) {
  if (!data || !show) return null;
  const form = useForm<ReplaceFileSchema>({
    resolver: zodResolver(replaceFileSchema),
    values: {
      title: data.title,
      description: data.description ?? '',
      file: undefined,
    },
  });

  const handleSuccess = () => {
    form.reset();
    onHide?.();
  };

  const mutationFn = (value: ReplaceFileSchema) => replaceFile(data.id, value);
  const {
    mutateAsync, isLoading, reset,
  } = useFileExplorerMutation({
    mutationFn,
    onSuccess: handleSuccess,
  });

  const handleClose = () => {
    form.reset();
    reset();
    onHide?.();
  };

  const handleReplace = (values: ReplaceFileSchema) => {
    const replacePromise = mutateAsync(values);
    toast.promise(replacePromise, {
      loading: 'Reemplazando archivo...',
      success: 'Archivo reemplazado exitosamente',
      error: {
        message: 'Error reemplazando archivo',
        description: GENERIC_ERROR_MESSAGE,
      },
    });
  };
  return (
    <ControlledModal
      show={show}
      onHide={handleClose}
      title="Reemplazar archivo"
      closeButton
      centered
    >
      <Modal.Body>
        <ReplaceFileForm form={form} onSubmit={handleReplace}>
          <ControlledModal.Actions handleClose={handleClose} isPending={isLoading} cancelButton />
        </ReplaceFileForm>
      </Modal.Body>
    </ControlledModal>
  );
}
